import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { getCurrentUser } from '../../../api/actions/get-current-user';
import { MainLayout } from '../../../components/layouts/main-layout';
import { CurrentUserContext } from '../../../contexts/current-user-context';
import { basePerformError } from '../../../helpers/error-helpers';
import { SecuredPage } from '../../base/secured-page';
import { GroupSelectComponent } from './components/group-select-component';
import styles from './group-select-page.module.scss';

export function GroupSelectPage(props: RouteComponentProps) {
  const currentUserContext = React.useContext(CurrentUserContext);
  React.useEffect(() => {
    (async () => {
      try {
        const usr = await getCurrentUser();
        currentUserContext?.setState(usr);
      } catch (err) {
        basePerformError(err, props.history);
        return;
      }
    })().catch(() => {
      /** */
    });
  }, [props]);

  return (
    <SecuredPage pageName="group-select" {...props}>
      <MainLayout>
        <div>
          {currentUserContext?.state?.uid && (
            <GroupSelectComponent
              user={currentUserContext?.state}
              history={props.history}
            />
          )}
        </div>
      </MainLayout>
    </SecuredPage>
  );
}
